"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impactShopUnitTypeMapping = exports.impactShopProductUnitTypePluralMapper = exports.createImpactShopBasketProduct = exports.areImpactShopBasketProductsEqual = void 0;
const impact_1 = require("../impact");
const utils_1 = require("../utils");
const areImpactShopBasketProductsEqual = (productA, productB) => productA.id === productB.id &&
    (0, utils_1.normaliseString)(productA.fundedBy) === (0, utils_1.normaliseString)(productB.fundedBy);
exports.areImpactShopBasketProductsEqual = areImpactShopBasketProductsEqual;
const createImpactShopBasketProduct = (product, quantity, fundedBy) => ({
    id: product.id,
    display: product.display,
    fundedBy: fundedBy,
    minQuantity: product.minQuantity,
    maxQuantity: product.maxQuantity,
    quantity: quantity,
    prices: product.prices,
});
exports.createImpactShopBasketProduct = createImpactShopBasketProduct;
exports.impactShopProductUnitTypePluralMapper = {
    tree: 'trees',
    'tonne CO2e': 'tonnes CO2e',
    kg: 'kg',
    m2: 'squared meters',
};
/**
  * Converts from Impact Shop unit into ImpactUnit
  */
exports.impactShopUnitTypeMapping = {
    'tonne CO2e': 'tonnes',
    kg: 'kilograms',
    tree: null,
    'm2': 'm2',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wYWN0LXNob3AtcHJvZHVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pbXBhY3Qtc2hvcC9pbXBhY3Qtc2hvcC1wcm9kdWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHNDQUF1QztBQUd2QyxvQ0FBMkM7QUFFcEMsTUFBTSxnQ0FBZ0MsR0FBRyxDQUM5QyxRQUFpQyxFQUNqQyxRQUFpQyxFQUNqQyxFQUFFLENBQ0YsUUFBUSxDQUFDLEVBQUUsS0FBSyxRQUFRLENBQUMsRUFBRTtJQUMzQixJQUFBLHVCQUFlLEVBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxLQUFLLElBQUEsdUJBQWUsRUFBQyxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUM7QUFML0QsUUFBQSxnQ0FBZ0Msb0NBSytCO0FBRXJFLE1BQU0sNkJBQTZCLEdBQUcsQ0FDM0MsT0FBOEIsRUFDOUIsUUFBZ0IsRUFDaEIsUUFBZ0IsRUFDUyxFQUFFLENBQUMsQ0FBQztJQUM3QixFQUFFLEVBQUUsT0FBTyxDQUFDLEVBQUU7SUFDZCxPQUFPLEVBQUUsT0FBTyxDQUFDLE9BQU87SUFDeEIsUUFBUSxFQUFFLFFBQVE7SUFDbEIsV0FBVyxFQUFFLE9BQU8sQ0FBQyxXQUFXO0lBQ2hDLFdBQVcsRUFBRSxPQUFPLENBQUMsV0FBVztJQUNoQyxRQUFRLEVBQUUsUUFBUTtJQUNsQixNQUFNLEVBQUUsT0FBTyxDQUFDLE1BQU07Q0FDdkIsQ0FBQyxDQUFDO0FBWlUsUUFBQSw2QkFBNkIsaUNBWXZDO0FBNkJVLFFBQUEscUNBQXFDLEdBRzlDO0lBQ0YsSUFBSSxFQUFFLE9BQU87SUFDYixZQUFZLEVBQUUsYUFBYTtJQUMzQixFQUFFLEVBQUUsSUFBSTtJQUNSLEVBQUUsRUFBRSxnQkFBZ0I7Q0FDckIsQ0FBQztBQUVGOztJQUVJO0FBQ1MsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxZQUFZLEVBQUUsUUFBaUI7SUFDL0IsRUFBRSxFQUFFLFdBQW9CO0lBQ3hCLElBQUksRUFBRSxJQUFJO0lBQ1YsSUFBSSxFQUFFLElBQWE7Q0FDbUMsQ0FBQyJ9